export default "__VITE_ASSET__Dt9Voeq1__"